import { render, staticRenderFns } from "./BT-ClearanceDep.vue?vue&type=template&id=a104dcae&scoped=true&"
import script from "./BT-ClearanceDep.vue?vue&type=script&lang=js&"
export * from "./BT-ClearanceDep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a104dcae",
  null
  
)

export default component.exports